interface SidebarHeaderProps {
  onClose?: () => void;
}

export const SidebarHeader = ({ onClose }: SidebarHeaderProps) => {
  return (
    <div className="sticky top-0 bg-global-primary/95 border-b border-global-secondary backdrop-blur-sm z-10">
      <div className="px-3 py-2.5 flex items-center gap-2.5">
        <div className="w-8 h-8 bg-linear-to-br from-global-accent to-global-accent/70 rounded-lg flex items-center justify-center shadow-sm">
          <svg
            className="w-4 h-4 sidebar-header-icon"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
            />
          </svg>
        </div>
        <div className="min-w-0 flex-1">
          <h2 className="text-size-sm font-bold text-global-primary truncate">
            Centro de control
          </h2>
          <p className="text-size-2xs text-global-tertiary">
            Información y guía de uso
          </p>
        </div>
        {onClose ? (
          <button
            type="button"
            onClick={onClose}
            className="w-6 h-6 flex items-center justify-center rounded-md text-global-tertiary hover:text-global-primary hover:bg-global-overlay-secondary transition-colors"
            aria-label="Close"
          >
            <svg
              className="w-4 h-4"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        ) : (
          <div className="w-2 h-2 bg-(--metric-sales) rounded-full shrink-0" />
        )}
      </div>
    </div>
  );
};
